var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGuru = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 41,
  viewBox: "0 0 41 41",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.993 24.36c.144 5.114-2.068 8.937-6.42 11.386-6.028 3.408-12.517 5.45-19.527 5.24-3.95-.127-7.111-2.025-9.182-5.337C1.898 29.302-.236 22.354.02 14.835c.136-3.957 2.175-7.053 5.502-9.093C11.79 1.902 18.615-.228 26.019.02c4.009.135 7.103 2.214 9.21 5.58 3.584 5.727 5.26 12.075 5.764 18.762Z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.387 28.5a8.194 8.194 0 0 1-4.861.278c-3.788-1.027-6.538-4.486-6.538-8.252a8.335 8.335 0 0 1 2.493-6.09 8.512 8.512 0 0 1 5.835-2.455h.08c3.996.044 6.53 3.05 6.55 3.08a.997.997 0 0 0 1.4.144.99.99 0 0 0 .145-1.395c-.126-.153-3.124-3.756-8.072-3.81a10.467 10.467 0 0 0-7.407 3.099A10.394 10.394 0 0 0 10 20.52c0 4.647 3.368 8.925 8.01 10.167.798.21 1.62.316 2.446.313 1.23-.004 2.45-.222 3.605-.644 3.059-1.114 6.043-4.044 5.935-7.441-.697.5-1.426.956-2.18 1.365-.59 1.878-2.457 3.505-4.43 4.22Z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.34 18.317a15.344 15.344 0 0 1-2.072 1.842c-1.28-1.278-3.32-1.896-4.797-1.896-1.206 0-2.132.327-2.747.969A2.653 2.653 0 0 0 20 21.146c.02 1.342.956 2.793 3.514 2.852 1.427.036 2.822-.44 4.043-1.084a13.335 13.335 0 0 0 1.737-1.09 16.86 16.86 0 0 0 2.45-2.166c.36-.4.336-1.025-.052-1.395a.94.94 0 0 0-1.355.054h.002Zm-6.782 3.708c-.745-.018-1.628-.19-1.64-.91a.664.664 0 0 1 .17-.511c.137-.143.497-.38 1.383-.38a5.613 5.613 0 0 1 3.06 1.022 6.317 6.317 0 0 1-2.973.779Z",
  fill: "#FFF"
}))));

export default SvgGuru;